export default __webpack_public_path__ + "static/media/icon-caution.8b14cc03.webp";